var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OtherHeader',{attrs:{"img_header":_vm.header_image,"header":"ตั้งค่าเว็บไซต์อื่นๆ","link_back":"managewebsite"}}),_c('MenuOther'),_c('Policy_page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }